import { QueryStore } from '../runtime/stores/query'
import artifact from '$houdini/artifacts/duplicateVinQuery'
import { initClient } from '$houdini/plugins/houdini-svelte/runtime/client'

export class duplicateVinQueryStore extends QueryStore {
	constructor() {
		super({
			artifact,
			storeName: "duplicateVinQueryStore",
			variables: false,
		})
	}
}

export async function load_duplicateVinQuery(params) {
  await initClient()

	const store = new duplicateVinQueryStore()

	await store.fetch(params)

	return {
		duplicateVinQuery: store,
	}
}
